module.exports = __webpack_public_path__ + "static/Adegbola-bf0b02c73b44d4d50698d23657459ace.png";